(function () {
	'use strict';

	angular
		.module('franchiser.components')
		.controller('CompanyEconomicGroupsFranchiserFormController', CompanyEconomicGroupsFranchiserFormController)

	/** @ngInject */
	function CompanyEconomicGroupsFranchiserFormController($state, $stateParams, LoadingHelper, UtilHelper, sweetAlert, CompanyEconomicGroupService) {
		const vm = this;
		const companyEconomicGroupId = $stateParams.companyEconomicGroupId;

		vm.saveCompanyEconomicGroup = () => {
			LoadingHelper.startLoading('.loading-holder');

			if (!vm.companyEconomicGroupData.Id) {
				CompanyEconomicGroupService
					.post(vm.companyEconomicGroupData)
					.then(success => successCallback(success, true), errorCallback);
			} else {
				let companyEconomicGroupData = {
					Id: companyEconomicGroupId,
					Title: vm.companyEconomicGroupData.Title,
				};

				CompanyEconomicGroupService
					.put(companyEconomicGroupData)
					.then(success => successCallback(success, false), errorCallback);
			}
		}

		vm.deleteCompanyEconomicGroup = () => {
			sweetAlert.swal({
				title: 'Você tem certeza?',
				text: 'Não é possível desfazer essa ação!',
				type: 'warning',
				confirmButtonText: 'Sim, tenho certeza',
				showCancelButton: true,
				cancelButtonText: 'Não, cancelar',
				allowOutsideClick: false,
				allowEscapeKey: false
			}).then(response => {
				if (response.value) {
					LoadingHelper.startLoading('.loading-holder');

					CompanyEconomicGroupService
						.deleteData(companyEconomicGroupId)
						.then(() => {
							$state.go('app.franchiser-company-economic-groups-list')
							LoadingHelper.stopLoading('.loading-holder');
							UtilHelper.successCallback('delete');
						}, error => {
							UtilHelper.errorCallback(error);
							LoadingHelper.stopLoading('.loading-holder');
						})
				}
			})
		}

		init();

		function getCompanyEconomicGroup() {
			if (!companyEconomicGroupId)
				return;

			LoadingHelper.startLoading('.loading-holder');

			CompanyEconomicGroupService
				.get(companyEconomicGroupId)
				.then(success => {
					vm.companyEconomicGroupData = success;
					LoadingHelper.stopLoading('.loading-holder');
				}, error => {
					LoadingHelper.stopLoading('.loading-holder');
					UtilHelper.errorCallback(error);
				})
		}

		function successCallback(success, isPost) {
			if (isPost) {
				vm.companyEconomicGroupData = success;

				$state.go('app.franchiser-company-economic-groups-edit', {
					companyEconomicGroupId: vm.companyEconomicGroupData.Id
				}, {
					notify: false
				});

				UtilHelper.successCallback('create');
			} else {
				UtilHelper.successCallback('update');
			}

			LoadingHelper.stopLoading('.loading-holder');
		}

		function errorCallback(error) {
			LoadingHelper.stopLoading('.loading-holder');
			UtilHelper.errorCallback(error);
		}

		function init() {
			vm.companyEconomicGroupData = {};

			getCompanyEconomicGroup();
		}
	}
}());